import { crv, cva } from '@/styled-system/css';

export const paginationListStyles = cva({
  base: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
    listStyleType: 'none',
  },
  variants: {
    ...crv('showNumberButtons', {
      true: { justifyContent: 'center' },
      false: { justifyContent: 'space-between' },
    }),
  },
});
